@if (label) {
    <label
        [ngbTooltip]="labelTooltip"
        [ngClass]="{ 'required-field': isRequired && !hideRequired }"
        [for]="controlId"
        class="control-label for"
    >
        {{ label }}
    </label>
}
<ng-content></ng-content>
@if (isError) {
    @for (msg of errorMessages; track msg) {
        <span class="text-danger">{{ msg }}</span>
    }
}
